<app-form-modal
  title="Important Message"
  [(visible)]="visible"
  formId="addressOrdersForm"
  (cancelForm)="onCancel()"
  (visibleChange)="onVisibleChange($event)"
  [submitLabel]="(updateDefaultShippingOrdersState$ | async)?.isLoading ? 'Updating Addresses...' : 'Update Addresses'"
  [disabled]="(updateDefaultShippingOrdersState$ | async)?.isLoading"
>
  <div *ngIf="getOrderControls().length" class="pb-2">
    <form [formGroup]="addressOrdersForm" (ngSubmit)="onSubmit()" id="addressOrdersForm" data-cy="address-orders-form">
      <app-message *ngIf="showError" severity="error" data-cy="error-address-orders-message">
        {{ (updateDefaultShippingOrdersState$ | async)?.error?.uiMessage }}
      </app-message>
      <p class="p3 mt-0" data-cy="address-orders-summary-message">
        There {{ getOrderControls()!.length === 1 ? 'is' : 'are' }} {{ getOrderControls().length }} reorder(s) tied to
        the previous shipping address. Please select the shipping address for the order(s) below.
      </p>
      <div *ngFor="let control of getOrderControls(); let i = index">
        <h4 class="text-primary-blue-base mt-5 mb-0" data-cy="order-category">
          Category: {{ getOrder(control.get('orderId')?.value)?.shipmentTypeName }}
        </h4>
        <h4 class="text-primary-blue-base mt-0 mb-2" data-cy="order-estimated-ship-date">
          Est Ship Date:
          {{
            getOrder(control.get('orderId')?.value)?.isFutureOrder ||
            !getOrder(control.get('orderId')?.value)?.targetedShipDate
              ? 'To Be Determined'
              : (getOrder(control.get('orderId')?.value)?.targetedShipDate | formatDate)
          }}
        </h4>
        <app-form-field
          [control]="asFormControl(control.get('updateAddress'))"
          [name]="'updateAddress-' + i"
          type="radio"
          [options]="[
            { label: 'Currently shipping to ' + currentAddressStr, value: false },
            { label: 'Use new address ' + newAddressStr, value: true }
          ]"
        ></app-form-field>
      </div>
    </form>
  </div>
</app-form-modal>
